import FetchBase from '../Api/FetchBase'
import { observable, action, computed, values } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateName } from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'
import { ERROR_CODE } from '../Utils/constants'

export default class UsersStore extends FetchBase {
  @observable asyncEmailCheckLoader = false
  @observable platformUsersOrdering = undefined
  @observable platformUsersOrderingBy = undefined
  @observable platformUsersFilter = {}
  @observable platformUserSearchText = ''
  @observable platformUserPageNo = DEFAULT_PAGE_START
  @observable platformUsersLoader = false
  @observable platformUsers = []
  @observable platformUsersTotal = 0
  @observable superUserSystemRoleDropdownLoader = false
  @observable superUserSystemRoleDropdown = []

  @observable miiUsersOrdering = undefined
  @observable miiUsersOrderingBy = undefined
  @observable miiUsersFilter = {}
  @observable miiUsersSearchText = ''
  @observable miiUsersPageNo = DEFAULT_PAGE_START
  @observable miiUsersLoader = false
  @observable miiUsers = []
  @observable miiUsersTotal = 0

  @observable usersByMiiUserByIdLoader = false
  @observable usersByMiiUserById = []
  @observable userDetailsByMiiUserIdLoader = false
  @observable userDetailsByMiiUserId = []

  @observable usersRoleFromPlatformLoader = false
  @observable usersRoleFromPlatform = []

  @observable allUsersRoleFromPlatform = []
  @observable usersDropdownListByOrg = []

  @action.bound
  setAsyncEmailCheckLoder = (value = false) => {
    this.asyncEmailCheckLoader = value
  }

  @action.bound
  setPlatformUsersOrdering = (value = undefined) => {
    this.platformUsersOrdering = value
  }

  @action.bound
  setPlatformUsersOrderingBy = (value = undefined) => {
    this.platformUsersOrderingBy = value
  }

  @action.bound
  setPlatformUsersFilter = (value = {}) => {
    this.platformUsersFilter = value
  }

  @action.bound
  setPlatformUserSearchText = (value) => {
    this.platformUserSearchText = value
  }

  @action.bound
  setPlatformUserPage = (value = DEFAULT_PAGE_START) => {
    this.platformUserPageNo = value
  }

  @action.bound
  getFilterObjectForPlatfromUsers = () => {
    let options = {}
    let keys = Object.keys(this.platformUsersFilter || {})
    for (let filter of keys) {
      if (
        this.platformUsersFilter[filter] ||
        this.platformUsersFilter[filter] === false
      ) {
        options[filter] = this.platformUsersFilter[filter]
      }
    }
    this.platformUserSearchText &&
      (options['search'] = this.platformUserSearchText)
    if (this.platformUsersOrdering) {
      options['ordering'] = this.platformUsersOrdering
      options['orderBy'] = this.platformUsersOrderingBy
    }
    return options
  }

  @action.bound
  getAllPlatformUsers = async (signal) => {
    try {
      this.platformUsersLoader = true
      let filter = this.getFilterObjectForPlatfromUsers()
      let options = { ...filter }
      let response = await this.post(
        API_ENDPOINTS.GET_PLATFORM_USERS,
        {
          ...options,
          pageNo: Math.max(this.platformUserPageNo - 1, 0),
        },
        signal
      )
      if (response.status) {
        this.platformUsers = response.data?.platFormUsers || []
        this.platformUsersTotal = response.data?.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.platformUsersLoader = false
    }
  }

  @action.bound
  getAllPlatformUsersExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFilterObjectForPlatfromUsers()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PLATFORM_USERS, {
        ...options,
        pageNo: Math.max(this.platformUserPageNo - 1, 0),
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deletePlatformUSerById = async (id) => {
    if (!id) {
      return
    }
    try {
      let response = await this.post(
        API_ENDPOINTS.DELETE_USER_BY_PLATFORM_USER,
        {
          userId: id,
        }
      )
      return response.status
    } catch (err) {
      return false
    }
  }

  deletePlatformUSerByIdLocally = (id) => {
    let platformUsers = this.platformUsers
    this.platformUsersTotal = this.platformUsersTotal - 1
    if (id && platformUsers) {
      this.platformUsers = (platformUsers || []).filter(
        (platformUser) => platformUser.id !== id
      )
    }
  }

  @action.bound
  resetUserFilters = () => {
    this.platformUsersFilter = {}
    this.platformUsersOrdering = undefined
    this.platformUsersOrderingBy = undefined
  }

  @action.bound
  getSuperUserSystemRoleDropdown = async (signal) => {
    try {
      this.superUserSystemRoleDropdownLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_SP_SYSTEM_ROLE,
        {},
        signal
      )
      if (response.status) {
        this.superUserSystemRoleDropdown = response.data || []
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.superUserSystemRoleDropdownLoader = false
    }
  }

  // MII User
  // @action.bound
  // setAsyncEmailCheckLoder = (value = false) => {
  //   this.asyncEmailCheckLoader = value
  // }

  @action.bound
  setMIIUsersOrdering = (value = undefined) => {
    this.miiUsersOrdering = value
  }

  @action.bound
  setMIIUsersOrderingBy = (value = undefined) => {
    this.miiUsersOrderingBy = value
  }

  @action.bound
  setMIIUsersFilter = (value = {}) => {
    this.miiUsersFilter = value
  }

  @action.bound
  setMIIUsersSearchText = (value) => {
    this.miiUsersSearchText = value
  }

  @action.bound
  setMIIUsersPage = (value = DEFAULT_PAGE_START) => {
    this.miiUsersPageNo = value
  }

  @action.bound
  getFilterObjectForMIIUsers = () => {
    let options = {}
    let keys = Object.keys(this.miiUsersFilter || {})
    for (let filter of keys) {
      if (
        this.miiUsersFilter[filter] ||
        this.miiUsersFilter[filter] === false
      ) {
        options[filter] = this.miiUsersFilter[filter]
      }
    }
    this.miiUsersSearchText && (options['search'] = this.miiUsersSearchText)
    if (this.miiUsersOrdering) {
      options['ordering'] = this.miiUsersOrdering
      options['orderBy'] = this.miiUsersOrderingBy
    }
    return options
  }

  @action.bound
  getAllMIIUsers = async (signal) => {
    try {
      this.miiUsersLoader = true
      let filter = this.getFilterObjectForMIIUsers()
      let options = { ...filter }
      let response = await this.post(
        API_ENDPOINTS.GET_MII_USERS,
        {
          ...options,
          pageNo: Math.max(this.miiUsersPageNo - 1, 0),
        },
        signal
      )
      if (response.status) {
        this.miiUsers = response.data?.allUsers || []
        this.miiUsersTotal = response.data?.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.miiUsersLoader = false
    }
  }

  @action.bound
  getAllMIIUsersExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFilterObjectForMIIUsers()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_MII_USERS, {
        ...options,
        pageNo: Math.max(this.miiUsersPageNo - 1, 0),
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateMiiUsersEmail = async (userId, values) => {
    try {
      this.updateMiiUsersEmailLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_MII_USER_BY_ID, {
        userId,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateMiiUsersEmailLoader = false
    }
  }

  @action.bound
  updateMiiUsersLocally = async (id, responseData) => {
    this.miiUsers = (this.miiUsers || []).map((user) => {
      if (user.id === id) {
        return responseData
      } else {
        return user
      }
    })
  }

  @action.bound
  deleteMIIUserById = async (id) => {
    if (!id) {
      return
    }
    try {
      let response = await this.post(
        API_ENDPOINTS.DELETE_USER_BY_PLATFORM_USER,
        {
          userId: id,
        }
      )
      return response.status
    } catch (err) {
      return false
    }
  }

  deleteMIIUserByIdLocally = (id) => {
    let miiUsers = this.miiUsers
    this.miiUsersTotal = this.miiUsersTotal - 1
    if (id && miiUsers) {
      this.miiUsers = (miiUsers || []).filter((miiUser) => miiUser.id !== id)
    }
  }

  @action.bound
  getMiiUserById = async (userId) => {
    try {
      this.usersByMiiUserByIdLoader = true
      let response = await this.get(API_ENDPOINTS.GET_USERS_BY_MII_USER_ID, {
        userId: userId,
      })
      if (response.status) {
        this.usersByMiiUserById = response.data || []
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.usersByMiiUserByIdLoader = false
    }
  }

  @action.bound
  getUserDetailsByMiiUserId = async (userId) => {
    try {
      this.userDetailsByMiiUserIdLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_SAPERATE_USER_BY_MII_USER_ID,
        {
          userId: userId,
        }
      )
      if (response.status) {
        this.userDetailsByMiiUserId = response.data || []
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.userDetailsByMiiUserIdLoader = false
    }
  }

  @action.bound
  resetMIIUserFilters = () => {
    this.miiUsersFilter = {}
    this.miiUsersOrdering = undefined
    this.miiUsersOrderingBy = undefined
  }
  @action.bound
  changeMiiUserStatusById = async (userId, orgId, status) => {
    try {
      this.userDetailsByMiiUserIdLoader = true
      let response = await this.post(
        API_ENDPOINTS.UPDATE_MII_USER_STATUS_BY_ID,
        {
          userId,
          orgId,
          status,
        }
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.userDetailsByMiiUserIdLoader = false
    }
  }

  @action.bound
  updateMiiUsersDetails = async (userId, orgId, values) => {
    try {
      this.userDetailsByMiiUserIdLoader = true
      const {
        profileImage,
        firstName,
        lastName,
        roleId,
        title,
        state,
        country,
        city,
        contactNumber,
      } = values
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_MII_USER_DETAILS_BY_ID,
        generateFormData({
          userId,
          orgId,
          profileImage,
          firstName,
          lastName,
          roleId,
          title,
          state,
          country,
          city,
          contactNumber,
        })
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.userDetailsByMiiUserIdLoader = false
    }
  }

  @action.bound
  updateMiiUsersDetailsLocally = async (responseData) => {
    this.usersByMiiUserById = responseData
  }

  @action.bound
  deleteMiiUsersDetailsById = async (id, orgId) => {
    if (!id) {
      return
    }
    try {
      let response = await this.post(
        API_ENDPOINTS.DELETE_USER_BY_PLATFORM_USER_WITH_ORG,
        {
          userId: id,
          orgId: orgId,
        }
      )
      return response.status
    } catch (err) {
      return false
    }
  }

  @action.bound
  getRolesDropdownFromPlatform = async (orgId, isCustomerRole) => {
    try {
      this.usersRoleFromPlatformLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_SP_ROLE_BY_USER_TYPE,
        {
          orgId,
          isCustomerRole,
        }
      )
      if (response.status) {
        this.usersRoleFromPlatform = response.data || []
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.usersRoleFromPlatformLoader = false
    }
  }

  @action.bound
  getAllUsersRoleDropdownFromPlatform = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_ALL_USERS_SYSTEM_ROLE,
        {},
        signal
      )
      if (response.status) {
        this.allUsersRoleFromPlatform = response.data || []
        return true
      }
    } catch (err) {
      this.allUsersRoleFromPlatform = []
      return false
    }
  }

  @action.bound
  getUsersDropdownByOrgId = async (orgId) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_USERS_BY_ORG_ID,
        { orgId }
      )
      if (response.status) {
        this.usersDropdownListByOrg = response.data
        return true
      }
    } catch (err) {
      this.usersDropdownListByOrg = []
      return false
    }
  }

  @action.bound
  changeSuperAdmin = async (orgId, values) => {
    try {
      this.changeSuperAdminLoader = true
      let response = await this.post(API_ENDPOINTS.UPER_ADMIN_CREATE_CHANGE, {
        orgId,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.changeSuperAdminLoader = false
    }
  }

  @action.bound
  resetStore = () => {
    this.asyncEmailCheckLoader = false
    this.platformUsersOrdering = undefined
    this.platformUsersOrderingBy = undefined
    this.platformUsersFilter = {}
    this.platformUserSearchText = ''
    this.platformUserPageNo = DEFAULT_PAGE_START
    this.platformUsersLoader = false
    this.platformUsers = []
    this.platformUsersTotal = 0
    this.superUserSystemRoleDropdownLoader = false
    this.superUserSystemRoleDropdown = []

    this.miiUsersOrdering = undefined
    this.miiUsersOrderingBy = undefined
    this.miiUsersFilter = {}
    this.miiUsersSearchText = ''
    this.miiUsersPageNo = DEFAULT_PAGE_START
    this.miiUsersLoader = false
    this.miiUsers = []
    this.miiUsersTotal = 0

    this.usersByMiiUserByIdLoader = false
    this.usersByMiiUserById = []
    this.userDetailsByMiiUserIdLoader = false
    this.userDetailsByMiiUserId = []

    this.usersRoleFromPlatformLoader = false
    this.usersRoleFromPlatform = []
    this.allUsersRoleFromPlatform = []
    this.usersDropdownListByOrg = []
  }
}
